import type { PriceEstimatorDialogPlanType } from '@ctct/presentation-layer';

import type { TranslationPaths } from '../../../types';

export interface PriceEstimatorDialogI18nKeys {
  heading: TranslationPaths;
  ok: TranslationPaths;
  listSize: TranslationPaths;
  plans: Record<PriceEstimatorDialogPlanType, TranslationPaths>;
  unknownPlanType: TranslationPaths;
  overageMessage: TranslationPaths;
  contactSales: TranslationPaths;
}

const priceEstimatorDialogI18nKeys: PriceEstimatorDialogI18nKeys = {
  heading: 'application-layer.upgrade-price-estimator.dialog-heading',
  ok: 'application-layer.upgrade-price-estimator.ok',
  listSize: 'application-layer.upgrade-price-estimator.table.header.list-size',
  plans: {
    GOOD: 'application-layer.upgrade-price-estimator.plans.GOOD',
    BETTER: 'application-layer.upgrade-price-estimator.plans.BETTER',
    LITE: 'application-layer.upgrade-price-estimator.plans.LITE',
    GROWTH: 'application-layer.upgrade-price-estimator.plans.GROWTH',
    BRONZE: 'application-layer.upgrade-price-estimator.plans.BRONZE',
    SILVER: 'application-layer.upgrade-price-estimator.plans.SILVER',
    GOLD: 'application-layer.upgrade-price-estimator.plans.GOLD',
  },
  unknownPlanType: 'application-layer.upgrade-price-estimator.unknownPlanType',
  overageMessage: 'application-layer.upgrade-price-estimator.overage-msg',
  contactSales: 'application-layer.upgrade-price-estimator.contact-sales',
};

export class TranslationsService {
  api() {
    return {};
  }

  data() {
    return {
      getPriceEstimatorDialogI18nKeys: () => priceEstimatorDialogI18nKeys,
    };
  }

  handlers() {
    return {};
  }
}
